import React from "react";
import { FE2_BOOKING_PROGRESS, FE2_PREVIEW_STEPS } from "../mock/flightEngineMockData";
import "./FlightProgress.css";

export default function FlightProgress({ activeStep }) {
  const steps = FE2_PREVIEW_STEPS.filter((s) =>
    FE2_BOOKING_PROGRESS.includes(s.id)
  );
  const activeIndex = Math.max(
    0,
    steps.findIndex((s) => s.id === activeStep)
  );

  return (
    <nav className="fe2-progress" aria-label="שלבי הזמנה">
      <ol className="fe2-progress__list">
        {steps.map((step, index) => {
          const state =
            index < activeIndex
              ? "done"
              : index === activeIndex
                ? "active"
                : "todo";
          return (
            <li
              key={step.id}
              className={`fe2-progress__item fe2-progress__item--${state}`}
            >
              <span className="fe2-progress__dot" aria-hidden />
              <span className="fe2-progress__label">{step.label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
